// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__2sSqE","logo":"Header_logo__glHWH"};